import { useNavigate } from 'react-router'
import { Helmet } from 'react-helmet-async'
import Landing from '../../Esg/Landing'
import StartedWith from '../../Esg/StartedWith'
const UNGCNIIMAGES = [
    {
        img: '/assets/images/eventGallery/UNGCNI-1.jpg',
        customStyle: {},
        customClassName: "md:w-[48%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/UNGCNI-2.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/UNGCNI-3.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/UNGCNI-4.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/UNGCNI-5.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/UNGCNI-6.jpg',
        customStyle: {},
        customClassName: "md:w-[48%] w-[100%]"
    },
]

const AUTOMATIONIMAGES = [
    {
        img: '/assets/images/eventGallery/automation-1.jpg',
        customStyle: {},
        customClassName: "md:w-[48%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/automation-2.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/automation-3.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/automation-4.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/automation-5.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/automation-6.jpg',
        customStyle: {},
        customClassName: "md:w-[48%] w-[100%]"
    },
]

const VAJRAESGIMAGES = [
    {
        img: '/assets/images/eventGallery/VajraESG-1.jpg',
        customStyle: {},
        customClassName: "md:w-[48%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/VajraESG-2.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/VajraESG-3.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/VajraESG-4.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/VajraESG-5.jpg',
        customStyle: {},
        customClassName: "md:w-[24.5%] w-[100%]"
    },
    {
        img: '/assets/images/eventGallery/VajraESG-6.jpg',
        customStyle: {},
        customClassName: "md:w-[48%] w-[100%]"
    },
]


function EventAndGallery() {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>ESG Events, Conferences & Sustainability Gallery | Nirantara</title>
                <meta name="description" content="Explore Nirantara's participation in ESG conferences, UN Global Compact events, and sustainability workshops. View our gallery of impactful moments shaping the future of responsible business." />
                <meta name="keywords" content="ESG events India, sustainability conferences, UN Global Compact event participation, ESG workshops, sustainability gallery, ESG event Nirantara, sustainability seminar India" />
                <link rel="canonical" href="https://nirantara.solutions/event-gallery" />
            </Helmet>
      <h1 className="sr-only">UNGCNI Regional Convention (West) Advancing ESG and AI-Driven Innovation</h1>
            <Landing
                image={"/assets/images/eventGallery/main-img.jpg"}
                text={"Event and \nGallery "}
            />
            <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
                <div className="flex flex-col-reverse md:grid md:grid-cols-1">
                    <div className="flex flex-col justify-between w-full py-0 mx-auto text-white md:py-10">
                        <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
                            UNGCNI Regional Convention (West) – Advancing ESG and AI-Driven Innovation
                        </h2>
                        <p className="mb-4 text-[#000000] text-lg leading-10">
                            Nirantara participated in the UNGCNI Regional Convention , West to showcase how ESG and AI can converge to accelerate sustainable development. Our Founder, Prasanna Rao, led the ESG Tech Lab workshop on innovation-ready digital tools for sustainability.
                        </p>
                    </div>
                </div>
                <div className="flex flex-wrap gap-4">
                    {UNGCNIIMAGES.map(({ img, customStyle, customClassName }, index) => (
                        <img
                            key={index}
                            src={img}
                            style={customStyle}
                            alt={`UNGCNI Event ${index + 1}`}
                            className={customClassName}
                        />
                    ))}
                </div>
            </section>
            <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
                <div className="flex flex-col-reverse md:grid md:grid-cols-1">
                    <div className="flex flex-col justify-between w-full py-0 mx-auto text-white md:py-10">
                        <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
                            Automation India Expo 2025 – Showcasing the Vajra ESG Tech Platform
                        </h2>
                        <p className="mb-4 text-[#000000] text-lg leading-10">
                            Nirantara Ecoventures exhibited at Automation India Expo 2025, Asia’s largest automation and smart manufacturing exhibition, showcasing our flagship Vajra ESG Tech Platform. Through live demos and interactions, we demonstrated how Vajra enables organizations to simplify compliance, enhance transparency, and make sustainability measurable and actionable.
                        </p>
                    </div>
                </div>
                <div className="flex flex-wrap gap-4">
                    {AUTOMATIONIMAGES.map(({ img, customStyle, customClassName }, index) => (
                        <img
                            key={index}
                            src={img}
                            style={customStyle}
                            alt={`Automation Event ${index + 1}`}
                            className={customClassName}
                        />
                    ))}
                </div>
            </section>

            <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
                <div className="flex flex-col-reverse md:grid md:grid-cols-1">
                    <div className="flex flex-col justify-between w-full py-0 mx-auto text-white md:py-10">
                        <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
                            Vajra ESG Tech Platform Launch – Empowering Sustainable Transformation
                        </h2>
                        <p className="mb-4 text-[#000000] text-lg leading-10">
                            Nirantara Ecoventures officially launched the Vajra ESG Tech Platform, a next-generation solution designed to empower organizations in Measure, Manage, and Monetize their ESG journey. The event brought together sustainability leaders, industry experts, and innovators to explore how Vajra drives transparency, compliance, and responsible business transformation.
                        </p>
                    </div>
                </div>
                <div className="flex flex-wrap gap-4">
                    {VAJRAESGIMAGES.map(({ img, customStyle, customClassName }, index) => (
                        <img
                            key={index}
                            src={img}
                            style={customStyle}
                            alt={`Vajra ESG Event ${index + 1}`}
                            className={customClassName}
                        />
                    ))}
                </div>
            </section>
            <StartedWith
                heading={"Join Our Team"}
                content1={"Looking to make a positive impact in ESG and sustainability? Explore opportunities to grow with Nirantara."}
                button1={"View Careers"}
                btn1OnClick={() => { navigate('/career') }}
            />
        </>
    )
}

export default EventAndGallery